export default __webpack_public_path__ + "static/NotoSans-Italic-4e7f010ed503309dbc2bd35a9ad2730e.ttf";